export default __webpack_public_path__ + "static/media/Blob.815ffa41.svg";